import { render, staticRenderFns } from "./PanelCompetitionSettingConfirmation.vue?vue&type=template&id=7cf3fe40&scoped=true&"
import script from "./PanelCompetitionSettingConfirmation.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingConfirmation.vue?vue&type=style&index=0&id=7cf3fe40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf3fe40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cf3fe40')) {
      api.createRecord('7cf3fe40', component.options)
    } else {
      api.reload('7cf3fe40', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingConfirmation.vue?vue&type=template&id=7cf3fe40&scoped=true&", function () {
      api.rerender('7cf3fe40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionSettingConfirmation.vue"
export default component.exports